import { PRIME_GLYPHS, type PrimeGlyphName } from "./prime-glyphs";

// A PRIMEICONS `pi pi-*` ICON AS INLINE SVG (OUTLINES IN `prime-glyphs.ts`). SVG FONT
// GLYPHS ARE Y-UP (UNITS-PER-EM 1024, ASCENT 960), HENCE THE FLIP; THE GLYPH FILLS ONE
// EM, AS THE FONT ICON WOULD AT THE SAME `size`. PRIMEICONS DEFAULT TO 1EM (14PX).
export function PrimeGlyph({ name, size = 14 }: { name: PrimeGlyphName; size?: number | string }) {
  const glyph = PRIME_GLYPHS[name];
  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${glyph.adv} 1024`}
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
      style={{ flexShrink: 0, display: "block" }}
    >
      <path transform="translate(0 960) scale(1 -1)" d={glyph.d} />
    </svg>
  );
}
